<template>
  <!--内容列表-->
    <div id="onLiveList">
      <div class="allSearch">
        <div class="newSearch d_flex">
          <div style="width: auto;white-space: normal">
            <p>
              <input @keyup.enter="getList(1)" class="allInput" placeholder="ID" type="text" v-model="postData.id">
            </p>

            <p>
              <input @keyup.enter="getList(1)" class="allInput" placeholder="内容标题" type="text" v-model="postData.title">
            </p>

            <p>
              <input @keyup.enter="getList(1)" class="allInput" placeholder="标签" type="text" v-model="postData.tag">
            </p>
            
            <button @click="getList(1)" class="redButton">搜索</button>
            
            <button @click="exportFile" class="redButton">导出</button>
          </div>
        </div>
      </div>
      
      <div class="allTablePlace" style="margin-top: 0;padding-top: 0;">
        <p style="margin: 0;padding: 0;color:#ccc;font-size: 12px;">注：AI推荐标签后，检查时人工进行了删除和新增，删除的标签则会在“AI推荐标签（已审核）”处标记红框，新增的标签则会在“人工修正后标签”处标记红框</p>
        <div>
          <table cellspacing="0" class="allTable" style="width:100%;table-layout: fixed">
            <thead>
            <tr>
              <th style="width:5%">ID</th>

              <th style="width:20%">内容标题</th>
              
              <th style="width:10%">上传时间</th>
              <th style="width:10%">创建人</th>
              <th style="width:25%">AI推荐标签(已审核)
              </th>
              <th style="width:25%">AI推荐标签(未审核)</th>
              <th style="width:25%">人工修正后标签</th>

            </tr>
            </thead>
            <tbody>
            <tr :key="index" v-for="(item, index) in myList">
              <td style="width:20%" class="NoWrap" :title="item.id">{{item.id}}</td>
              <td style="width:20%" class="NoWrap" :title="item.title">{{item.title}}</td>
              <td style="width:20%" class="NoWrap" :title="item.creationTime">{{ item.creationTime }}</td>
              
              <td style="width:10%" class="NoWrap" :title="item.createName">{{item.createName}}</td>
              <td style="width:20%;white-space: normal;" >
                <span class="warpTd" :style="tags.type===1?'border-color:red':''" v-for="(tags,index) in item.auditedAITags" :key="index">{{ tags.name}}</span>
              </td>
              <td style="width:20%;white-space: normal;" :title="item.url">
                <span class="warpTd" :style="tags.type===1?'border-color:red':''" v-for="(tags,index) in item.unauditedAITags" :key="index">{{ tags.name}}</span>
              </td>
              <td style="width:20%;white-space: normal;"  :title="item.url">
                <span class="warpTd" :style="tags.type===1?'border-color:red':''" v-for="(tags,index) in item.manualTags" :key="index">{{ tags.name}}</span>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <page v-if="totalPage !== 0" :totalCount="totalCount" v-on:on-getList="getList($event)" :totalPage="totalPage" :page="page" :explain="0"></page>
      </div>
  
    </div>
  </template>
  
  <script>
   import connom from '../../../assets/js/common'
  export default {
    name: 'onLiveList',
    data () {
      return {
        baseUrl: process.env.config.baseUrl,
        totalPage: 1,
        totalCount: 0,
        page: 1,
        postData: {
          id:'',
          title: '',
          tag: '',
          pageIndex: 1,
          pageSize: this.$commonJs.commonPageSize
          
        },
        myList: [],
      }
    },
    created () {
      this.getList(1)
    },
    methods: {
      getList (pageIndex) {
        this.postData.pageIndex = pageIndex

      this.$axiox.post('/api/Article/article/Aitag/list',this.postData).then(msg => {
            console.log(msg)
            this.myList = msg.data
            this.page = pageIndex
            this.totalPage = Math.ceil(msg.total / this.postData.pageSize)
            this.totalCount = msg.total
      })

      },
      exportFile(){
        var xmlResquest = new XMLHttpRequest()
      if (window.XMLHttpRequest) { // Mozilla 浏览器
        xmlResquest = new XMLHttpRequest()
      } else {
        if (window.ActiveXObject) { // IE 浏览器
          try {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Microsoft.XMLHTTP')
          } catch (e) {
            // eslint-disable-next-line no-undef
            xmlResquest = new ActiveXObject('Msxml2.XMLHTTP')
          }
        }
      }
      let data = {
        Title:this.postData.title,
        Tag:this.postData.tag,
        Id:this.postData.id,
      }
      let url = this.$commonJs.returnQuery(this.baseUrl + '/api/Article/article/Aitag/export', data)
      xmlResquest.open('GET', url, true)
      xmlResquest.setRequestHeader('Content-type', 'application/json')
      xmlResquest.setRequestHeader('Authorization', 'Bearer ' + window.sessionStorage.getItem('TaToken'))
      xmlResquest.responseType = 'blob'
      xmlResquest.onload = function (oEvent) {
        // var contentType = xmlResquest.getResponseHeader('Content-Type');
        // if(contentType==='application/json'){
        //   connom.alertTips({
        //         type: 'error',
        //         title: '错误',
        //         content: '仅可导出最大一个月时间的数据，请调整筛选条件后再尝试',
        //         stayTime: 5
        //       })
        //   return
        // }
        var content = xmlResquest.response
        var elink = document.createElement('a')
        elink.download = 'AI标签分析列表.xlsx'
        elink.style.display = 'none'
        var blob = new Blob([content])
        elink.href = URL.createObjectURL(blob)
        document.body.appendChild(elink)
        elink.click()
        document.body.removeChild(elink)
      }
      xmlResquest.send()
      }
    },
  }
  </script>
  
  <style scoped>
  .forElClass >>> .el-date-editor.el-range-editor{
    width: 100%
  }
  .forElClass >>> .el-date-editor.el-input.el-input--prefix.el-input--suffix.el-date-editor--time {
    width: 148px!important
  }
  .forElClass >>> .el-date-editor.el-range-editor.is-active{
    background-color: #fff;
  }
  .forElClass >>> .el-range-editor.is-active, .forElClass >>> .el-range-editor.is-active:hover {
    border-color: #DEDEDE;
  }
  .fade-enter-active, .fade-leave-active {
      transition: opacity 0.7s
  }
  .fade-enter, .fade-leave-to {
      opacity: 0
  }
  .warpTd{
    border: 1px solid #ccc ;
    padding: 5px !important;
    display: inline-block !important;
    border-radius: 10px !important;
    margin: 2px 5px !important;
    
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/pages/tagManager/aiTagList.vue